import { gql } from '@apollo/client'

const BILLING_AGREEMENT_FRAGMENT = gql`
  fragment BillingAgreementFragment on BillingAgreement {
    __typename
    id
    type
    active
    paypalEmail
  }
`

const CREDIT_CARD_PAYMENT_METHOD_FRAGMENT = gql`
  fragment CreditCardPaymentMethodFragment on CreditCardPaymentMethod {
    __typename
    id
    type
    active
    lastFourDigits
    expMonth
    expYear
  }
`

const SEPA_DIRECT_DEBIT_FRAGMENT = gql`
  fragment SepaDirectDebitFragment on SepaDirectDebit {
    __typename
    id
    type
    active
    accountLastFour
  }
`

const MERCHANT_INITIATED_PAYMENT_FRAGMENT = gql`
  fragment MerchantInitiatedPaymentFragment on MerchantInitiatedPayment {
    __typename
    id
    type
    active
    merchantInitiatedType
  }
`

const PAYMENT_METHODS_FRAGMENT = gql`
  ${BILLING_AGREEMENT_FRAGMENT}
  ${CREDIT_CARD_PAYMENT_METHOD_FRAGMENT}
  ${SEPA_DIRECT_DEBIT_FRAGMENT}
  ${MERCHANT_INITIATED_PAYMENT_FRAGMENT}
  fragment PaymentMethodsFragment on User {
    __typename
    id
    subscription {
      __typename
      id
      status
      paymentMethods(archivedType: $archivedType) {
        ... on BillingAgreement {
          ...BillingAgreementFragment
        }
        ... on CreditCardPaymentMethod {
          ...CreditCardPaymentMethodFragment
        }
        ... on SepaDirectDebit {
          ...SepaDirectDebitFragment
        }
        ... on MerchantInitiatedPayment {
          ...MerchantInitiatedPaymentFragment
        }
      }
    }
  }
`

const BILLING_AGREEMENT_FRAGMENT_STRING = `
  fragment BillingAgreementFragment on BillingAgreement {
    __typename
    id
    type
    active
    paypalEmail
  }
`

const CREDIT_CARD_PAYMENT_METHOD_FRAGMENT_STRING = `
  fragment CreditCardPaymentMethodFragment on CreditCardPaymentMethod {
    __typename
    id
    type
    active
    lastFourDigits
    expMonth
    expYear
  }
`

const SEPA_DIRECT_DEBIT_FRAGMENT_STRING = `
  fragment SepaDirectDebitFragment on SepaDirectDebit {
    __typename
    id
    type
    active
    accountLastFour
  }
`

const MERCHANT_INITIATED_PAYMENT_FRAGMENT_STRING = `
  fragment MerchantInitiatedPaymentFragment on MerchantInitiatedPayment {
    __typename
    id
    type
    active
    merchantInitiatedType
  }
`

const PAYMENT_METHODS_FRAGMENT_STRING = `
  ${BILLING_AGREEMENT_FRAGMENT_STRING}
  ${CREDIT_CARD_PAYMENT_METHOD_FRAGMENT_STRING}
  ${SEPA_DIRECT_DEBIT_FRAGMENT_STRING}
  ${MERCHANT_INITIATED_PAYMENT_FRAGMENT_STRING}
  fragment PaymentMethodsFragment on User {
    __typename
    id
    subscription {
    __typename
      id
      status
      paymentMethods(archivedType: $archivedType) {
        ... on BillingAgreement {
          ...BillingAgreementFragment
        }
        ... on CreditCardPaymentMethod {
          ...CreditCardPaymentMethodFragment
        }
        ... on SepaDirectDebit {
          ...SepaDirectDebitFragment
        }
        ... on MerchantInitiatedPayment {
          ...MerchantInitiatedPaymentFragment
        }
      }
    }
  }
`

export {
  BILLING_AGREEMENT_FRAGMENT,
  CREDIT_CARD_PAYMENT_METHOD_FRAGMENT,
  SEPA_DIRECT_DEBIT_FRAGMENT,
  MERCHANT_INITIATED_PAYMENT_FRAGMENT,
  PAYMENT_METHODS_FRAGMENT,
  PAYMENT_METHODS_FRAGMENT_STRING
}
